import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";
import requestMiddlewares from "../../requestMiddlewares";

export interface ISignUpRequest {
  name: string;
  lastname: string;
  email: string;
  password: string;
}

export default async function signUpRequest(
  dispatch: Dispatch,
  data: ISignUpRequest,
): Promise<IResponse> {
  dispatch(startLoading());

  const request = new RACARequest('auth', 'signup')
    .setData(data);

  const response = await request.makeRequest();

  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
